import { UseMutationResult } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { UseFormRegister, UseFormReturn } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useShop from "../../hooks/useShop.hook";
import { SpecialistFormData } from "../../types/specialist";
import { EditorSection, SubmitPanel, Title } from "../reuseables/editor.comp";
import { LabelAndInput } from "../reuseables/form.comp";
import { selectCss } from "../reuseables/native.comp";

export default function SpecialistEditor({
  methods,
  mutation,
  btnName,
}: {
  methods: UseFormReturn<SpecialistFormData, any>;
  mutation: UseMutationResult<void, unknown, SpecialistFormData, unknown>;
  btnName: string;
}) {
  const { t, msg } = useTranslation();
  const selectedShop = useShop();
  const { push } = useRouter();

  async function onSubmit(data: SpecialistFormData) {
    mutation.mutate(data);
  }

  if (!selectedShop) return null;

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)} className="pb-20">
      <EditorSection>
        <Title>{t(msg.product.generalInfo)}</Title>
        <div className="text-xs flex flex-col gap-4">
          <SpecialistSelect register={methods.register} />
          <LabelAndInput register={methods.register} fieldName="firstName" label={t(msg.import.firstName)} topLabelCss="block" />
          <LabelAndInput register={methods.register} fieldName="lastName" label={t(msg.import.lastName)} topLabelCss="block" />
          <LabelAndInput register={methods.register} fieldName="email" label={t(msg.customer.emailL)} topLabelCss="block" />
          <LabelAndInput
            register={methods.register}
            fieldName="mobileNumber"
            label={t(msg.customer.mobile)}
            topLabelCss="block"
          />
        </div>
      </EditorSection>
      <SubmitPanel>
        <button onClick={() => push("/specialists")}>{t(msg.form.cancel)}</button>
        <input type="submit" value={btnName} />
      </SubmitPanel>
    </form>
  );
}

function SpecialistSelect({ register }: { register: UseFormRegister<SpecialistFormData> }) {
  const { t, msg } = useTranslation();

  return (
    <div className="mt-4">
      <label className="block">{t(msg.specialist.specialist)}</label>
      <select className={selectCss} {...register("type")}>
        <option value="optometrist">{t(msg.specialist.optometrist)}</option>
        <option value="tailor">{t(msg.specialist.tailor)}</option>
        <option value="driver">{t(msg.specialist.driver)}</option>
      </select>
    </div>
  );
}
